import {PropRef, useEffect} from 'preact/hooks';

export default function autoFocus(ref: PropRef<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) {
  useEffect(() => {
    if (!ref.current) return;
    ref.current.focus();
  }, [ref.current])
}